module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mint-icon",
    class: _vm.animateClass
  }, [_c('i', {
    staticClass: "iconfont mint-icon-i",
    class: _vm.name,
    style: (_vm.computeStyle),
    on: {
      "click": _vm.handleClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16aaf74a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/icon/src/icon.vue
// module id = 467
// module chunks = 0